<template>
    <div class="card mt-1">
        <div class="card-body">
            <div class=" d-flex justify-content-between align-items-center p-2">
                <div class="settlement-title p-2">Withdraw funds</div>
            </div>
            <div class="d-flex justify-content-between align-items-center">
              <button class="btn btn-green ms-3" @click="openDetail()">Withdraw funds now</button>

              <div class="help-icon-container">
                <img
                  class="help-icon me-2"
                  src="@/assets/images/icon/help.png"
                  alt="help icon"
                />
                <!-- 浮動提示 -->
                <div class="help-tooltip">
                  <div class="tooltip-header">
                    <span>Withdraw funds now</span>
                  </div>
                  <div class="tooltip-body">
                    <p>
                      Withdraw funds now allows you to instantly transfer funds from your Taxi1 account to your nominated bank account, PayID, or Taxi1 Card. This usually takes only a few seconds, however in some cases funds may be held and take a little longer to process.
                    </p>
                    <p>
                      A $0.80 processing fee applies each time you withdraw funds. No fee applies for withdrawal to card.
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div class="mt-2 p-2" v-if="hasResults">
                <div class="history-title p-2">Withdraw history</div>

                <template v-for="(payment) in withdrawStore.history" :key="date">
                  <div class="col-item d-flex justify-content-between align-items-center mt-2" >
                    <div>
                        <div class="col-date">{{ format(payment.created_at) }}</div>
                        <div class="col-ref mt-1">{{payment.driver?.first_name}}&nbsp;{{payment.driver?.middle_name}}&nbsp;{{payment.driver?.last_name}} | {{ payment.account_no }}</div>
                    </div>
                    <div>
                        <div class="col-pay">{{ formatCurrency(payment.paid) }}</div>
                        <div class="col-status text-green"  >Withdraw</div>
                    </div> 
                </div>
              </template>
            </div>
            <div class="p-2 no-result" v-else>
              <div class="no-result-text">No results found</div>
            </div>
            <div class="mt-5 mb-5">&nbsp;</div>
        </div>
    </div>

    <div class="pagination-container">
        
        <div class="your-account-container">
          <div  class="frame-account pe-2 ps-2">
              <div class="account-title">Your account</div>
              <div>
                  <img class="account-icon" src="@/assets/images/driver/account.png" />
              </div>
          </div>
          <div class="p-2">
              <div class="account-balance">Account balance</div>
              <div class="account-value">{{ driverStore.driverInfo?.account_balance }}</div>
              <div class="pending-text">Money in your account pending withdrawal</div>
          </div>
      </div>
    </div>  


    <Detail 
      v-if="showDetail"
      @close="closeDetail"
     />
</template>

<script setup>
import { ref,onMounted,computed } from 'vue';
import Detail from './detail.vue';
import { useWithdrawStore } from '@/store/driver/withdraw';
import {useDriverStore} from '@/store/driver/driver';
import { fetchDriverInfo } from '@/store/public'
import {useRouter} from 'vue-router'



const withdrawStore = useWithdrawStore()
const driverStore = useDriverStore()
const driverToken = localStorage.getItem('driverToken');
const router = useRouter()

// 控制 Detail 組件顯示的狀態
const showDetail = ref(false);

const hasResults = computed(() => withdrawStore.history.length > 0);

const format = (dateString) => {
  if (!dateString) return 'Invalid date';
  
  // 預期格式："DD/MM/YY HH:mm" 或僅 "DD/MM/YY"
  const parts = dateString.split(' ');
  const datePart = parts[0]; // 例如 "10/02/25"
  
  const dateArr = datePart.split('/');
  if (dateArr.length !== 3) return 'Invalid date';
  
  // 依序取得日、月、年
  const day = parseInt(dateArr[0], 10);
  const month = parseInt(dateArr[1], 10);
  let year = parseInt(dateArr[2], 10);
  
  // 假設兩位數年份小於50為2000年之後，大於等於50為1900年之後
  year = year < 50 ? 2000 + year : 1900 + year;
  
  const date = new Date(year, month - 1, day);
  if (isNaN(date.getTime())) return 'Invalid date';
  
  // 格式化輸出
  const dayFormatted = date.getDate().toString().padStart(2, '0');
  const monthNames = [
    "January", "February", "March", "April", "May", "June",
    "July", "August", "September", "October", "November", "December"
  ];
  const monthFormatted = monthNames[date.getMonth()];
  const yearFormatted = date.getFullYear();
  
  return `${dayFormatted} ${monthFormatted} ${yearFormatted}`;
};

const formatCurrency = (value) => {
  const absValue = Math.abs(value); // 取得絕對值並固定為兩位小數
  return value < 0 ? `-$${absValue}` : `$${absValue}`;
};

const openDetail = async () => {
  await fetchDriverInfo(driverToken);  // 重新更新 localStorage 中的 Driver
  const driver = JSON.parse(localStorage.getItem('Driver'));
  if (driver && driver.withdraw_enabled !== true) {
      return router.push('/');
  }else{
    showDetail.value = true;
  }
};

// 關閉 Detail 組件
const closeDetail = () => {
  showDetail.value = false;
};

onMounted(async () => {
  await withdrawStore.fetchWithdrawHistory()
  await driverStore.fetchDriverInfo()
})

</script>

<style scoped>

.card {
    position: absolute;
    top: 80px;
    left: 0;
    right: 0;
    z-index: 1;
    height: 90%;
    width: 100%; /* 設置寬度為 100% */
    overflow-y: auto;
    overflow-x: hidden; /* 防止左右滑動 */
    border-radius: 10px 10px 0px 0px;
}

.settlement-title{
    font-family: 'Euclid Square';
    font-style: normal;
    font-weight: 600;
    font-size: 24px;
    line-height: 30px;

    /* 1E1E2D */
    color: #1E1E2D;
}

.search-icon{
    /* Auto layout */
    display: flex;
    flex-direction: row;
    align-items: center;
    padding: 10px;
    gap: 10px;

    width: 36px;
    height: 36px;

    /* Grey 10% */
    background: #EEF1F4;
    border-radius: 6px;

    /* Inside auto layout */
    flex: none;
    order: 1;
    flex-grow: 0;
    cursor: pointer;
}

.help-icon {
    width: 30px;
    height: 30px;
    cursor: pointer;
  }
  
  /* 幫圖示包裹容器，做相對定位 */
  .help-icon-container {
    position: relative; 
    display: inline-block;
  }
  
  /* 實際 tooltip 區塊，初始隱藏 */
  .help-tooltip {
    position: absolute;
    top: 40px;       /* 依實際需求微調 */
    right: 30px;    /* 依實際需求微調 */
    width: 80vw;    /* 依設計需求可調整 */
    background: #fff;
    border: 2px solid #8476f4;
    border-radius: 8px;
    box-shadow: 0 2px 10px rgba(0,0,0,0.15);
    padding: 15px;
    z-index: 999;
    opacity: 0;
    pointer-events: none;
    transition: opacity 0.2s;
  }
  
  /* 滑鼠滑進 .help-icon-container 後，顯示 tooltip */
  .help-icon-container:hover .help-tooltip {
    opacity: 1;
    pointer-events: auto;
  }
  
  /* 樣式可依照需求再做微調 */
  .tooltip-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-weight: 600;
    margin-bottom: 10px;
    color: #051c2c;
  }
  .tooltip-close {
    background: none;
    border: none;
    font-size: 16px;
    cursor: pointer;
    color: #8476f4;
  }
  .tooltip-body {
    font-size: 14px;
    line-height: 1.4;
    color: #051c2c;
    /* 依照需求增添字型設定 */
  }

  .history-title{
    font-family: 'Euclid Square';
    font-style: normal;
    font-weight: 500;
    font-size: 20px;
    line-height: 25px;

    /* 1E1E2D */
    color: #1E1E2D;
  }

.col-item{
  padding-top: 10px;
  padding-bottom: 10px;
  border-bottom: 1px solid #99A6B4;
}

.col-date{
    font-family: 'Euclid Square';
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 20px;

    color: #1E1E2D;
}

.col-ref{
    font-family: 'Mulish';
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 18px;
    color: #5E707D;
}

.col-pay{
    font-family: 'Euclid Square';
    font-style: normal;
    font-weight: 500;
    font-size: 18px;
    line-height: 23px;
    display: flex;
    align-items: center;
    text-align: right;
    color: #051C2C;
}

.col-status{
    font-family: 'Mulish';
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 18px;
    text-align: right;
}

.text-green{
    color: #00c962;
}


.no-result {
  margin-top: 20px;
  background-color: #d9d9d9;
  border-radius: 12px;
  min-height: 150px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center; /* 確保文字居中 */
  padding: 20px; /* 增加一點內距來保持美觀 */
}

.no-result-text {
  font-family: 'Euclid Square';
  font-style: italic;
  font-weight: 500;
  font-size: 20px;
  line-height: 25px;
  color: #051C2C;
  margin-bottom: 8px; /* 與 search-again 保持距離 */
}

.search-again {
  font-family: 'Euclid Square';
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 20px;
  color: #5248DA;
  cursor: pointer; /* 可選：讓文字像按鈕一樣具有可點擊效果 */
}


/* Pagination section 固定在底部 */
.pagination-container {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  height: 10vh;
  padding: 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: #FFFFFF;
  box-shadow: 0px -2px 15px rgba(5, 28, 44, 0.15);
  border-radius: 12px 12px 0px 0px;
  z-index: 1;
}

.pagination-left,
.pagination-right {
  display: flex;
}

.pagination-center {
  display: flex;
  align-items: center;
  gap: 4px;
}

.arrow-icon {
  width: 28px;
  height: 28px;
}

.page-info {
  font-size: 16px;
  color: #333;
  display: flex;
  align-items: center;
  gap: 4px;
}

.page-input {
  width: 40px;
  height: 30px;
  text-align: center;
  font-size: 16px;
  color: #333;
  border: 1px solid #ccc;
  border-radius: 4px;
  margin: 0 5px;
}

button {
  border: none;
  background: none;
  cursor: pointer;
}

.your-account-container {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  height: 25vh; /* 佔據 20% 的視窗高度 */
  background-color: #f4f4f8;
  padding: 15px;
  z-index:1;
  border-radius: 20px 20px 0px 0px;
}

.account-title {

    /* Portal/Portal – H5 */
    font-family: 'Euclid Square';
    font-style: normal;
    font-weight: 500;
    font-size: 20px;
    line-height: 25px;
    display: flex;
    align-items: center;

    /* Navy */
    color: #051C2C;


    /* Inside auto layout */
    flex: none;
    order: 0;
    flex-grow: 0;
}

.calendar-icon {
  width: 24px;
  height: 24px;
}

.account-balance {
    /* Account balance */

    /* Portal/Portal – H7 */
    font-family: 'Euclid Square';
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 20px;

    /* Navy */
    color: #051C2C;


    /* Inside auto layout */
    flex: none;
    order: 0;
    flex-grow: 0;
}

.account-value{
    /* Portal/Portal – H2 bold */
    font-family: 'Euclid Square';
    font-style: normal;
    font-weight: 600;
    font-size: 36px;
    line-height: 46px;
    display: flex;
    align-items: center;

    /* Navy */
    color: #051C2C;


    /* Inside auto layout */
    flex: none;
    order: 1;
    align-self: stretch;
    flex-grow: 0;

}

.pending-text {

    /* Portal/Portal – body extra small */
    font-family: 'Mulish';
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 18px;
    /* identical to box height */

    /* Navy */
    color: #051C2C;

    opacity: 0.5;

    /* Inside auto layout */
    flex: none;
    order: 0;
    flex-grow: 1;

}

.payment-method{
    width: 134px;
    height: 22px;

    /* Portal/Portal – body small */
    font-family: 'Mulish';
    font-style: normal;
    font-weight: 400;
    font-size: 15px;
    line-height: 19px;

    /* Navy */
    color: #051C2C;


    /* Inside auto layout */
    flex: none;
    order: 0;
    flex-grow: 0;
}

.method-value{
    /* Frame 291 */
    box-sizing: border-box;

    /* Auto layout */
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    padding: 6px 10px;
    gap: 10px;

    height: 32px;

    /* Green */
    border: 2px solid #00C962;
    border-radius: 6px;

    /* Inside auto layout */
    flex: none;
    order: 1;
    flex-grow: 0;


    /* Portal/Portal – H7 */
    font-family: 'Euclid Square';
    font-style: normal;
    font-weight: 700;
    font-size: 16px;
    line-height: 20px;
    display: flex;
    align-items: center;
    text-align: center;

    /* Navy */
    color: #051C2C;

}

.account-icon{
    margin: 0 auto;


    width: 48px;
    height: 48px;


    /* Inside auto layout */
    flex: none;
    order: 1;
    flex-grow: 0;

}

.frame-account{
    display: flex;
    justify-content: space-between; /* 讓內容居左右兩端 */
    width: auto; /* 確保寬度覆蓋整個父容器 */
}

.btn-green {
  background: rgba(0, 201, 98, 1);
  color: black;
  border: none;
  width: 283px;
  height: 46px;
  border-radius: 30px;
  font-size: 18px;
  padding: 8px 24px;
}

.btn-green:hover {
  background-color: #00b452;
}

</style>

